<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userManagement',
})
</script>
<template>
  <router-view v-if="$route.name !== 'user'" />
  <div v-else class="main">
    <a-card>
      <div class="system-dictionary-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="用户ID:">
                <a-input v-model:value="state.tableData.param.userNumber" placeholder="请输入用户ID" :maxlength="20"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="手机号:">
                <a-input v-model:value="state.tableData.param.tel" placeholder="请输入手机号" :maxlength="11" allow-clear
                  @input="telInput" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button :loading="state.tableData.loading" class="search mr-[10px]!" @click="getTableData"
                  type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun mr-[10px]!" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex justify-start md:justify-end">
                <ant-button class="add" @click="openDialog('add', {})" type="primary" v-auth="'user.add'">
                  <PlusOutlined />新增用户
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">{{ index + 1 }}</template>
          <template v-if="column.key === 'freeze'">{{ record.freeze == '0' ? '禁用' : '启用' }}</template>
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <ant-button type="link" size="small" @click="openDialog('detail', record)">查看详情</ant-button>
              <ant-button type="link" size="small" @click="openDialog('power', record)"
                v-auth="'user.power'">权限分配</ant-button>
              <a-popconfirm :title="`确定${record.freeze == '0' ? '启用' : '禁用'}用户:${record.username}`"
                @confirm="onFreeze(record)">
                <ant-button type="link" size="small" v-auth="'user.freeze'">{{ record.freeze == '0' ? '启用' : '禁用'
                }}</ant-button>
              </a-popconfirm>
              <a-popconfirm :title="`确定删除用户:${record.nickName}?`" @confirm="onDelete(record)">
                <ant-button type="link" danger size="small" v-auth="'user.del'">删除</ant-button>
              </a-popconfirm>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <ModelAdd ref="ModelAddFormRef" @updatePage="getTableData" />
    <ModelPower ref="ModelPowerFormRef" @updatePage="getTableData" />
    <PasswordDialog ref="PasswordDialogRef" @update="handlePasswordUpdate" />
  </div>
</template>

<script setup lang="ts" name="userManagement">
import { reactive, onMounted, ref } from 'vue'
import { useUser } from '@/store/user'
import { useLogin } from '@/store/login'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import ModelAdd from './modelAdd.vue'
import ModelPower from './modelPower.vue'
import PasswordDialog from '@/views/system/member/dialogPassword.vue'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { verifiyNumberInteger } from '@/utils/toolsValidate'
const router = useRouter()
const userApi = useUser()
const loginStore = useLogin()
const ModelAddFormRef = ref()
const ModelPowerFormRef = ref()
const PasswordDialogRef = ref()

const columns = [
  { title: '序号', dataIndex: 'index', key: 'index', width: 60, ellipsis: true },
  { title: '用户ID', dataIndex: 'userNumber', key: 'userNumber', width: 200, ellipsis: true },
  { title: '用户昵称', dataIndex: 'nickName', key: 'nickName', width: 200, ellipsis: true },
  { title: '用户账号', dataIndex: 'username', key: 'username', width: 200, ellipsis: true },
  { title: '手机号', dataIndex: 'tel', key: 'tel', width: 200, ellipsis: true },
  { title: '状态', dataIndex: 'freeze', key: 'freeze', ellipsis: true },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime', ellipsis: true },
  { title: '操作', key: 'action', width: 320 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      userNumber: '',
      tel: ''
    }
  }
})

const telInput = () => {
  state.tableData.param.tel = verifiyNumberInteger(state.tableData.param.tel)
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => userApi.getUserPage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

// 打开弹窗
const openDialog = (type: string, record: any) => {
  if (type === 'power') {
    ModelPowerFormRef.value.openDialog(record)
    return
  } else if (type === 'detail') {
    router.push({ name: 'userDetail', params: { id: record.id } })
  } else {
    ModelAddFormRef.value.openDialog()
  }
}

// 重置
const resetFun = () => {
  state.tableData.param.userNumber = ''
  state.tableData.param.tel = ''
  state.tableData.param.pageNum = 1
}

// 删除
const onDelete = async (record) => {
  await userApi.userDel(record.id)
  message.success('删除成功')
  getTableData()
}

// 打开重置密码弹窗
const openPasswordDialog = (record) => {
  PasswordDialogRef.value.openDialog(record.id)
}

// 处理密码更新
const handlePasswordUpdate = async (data) => {
  try {
    await loginStore.changePwd(data)
    message.success('密码重置成功')
    PasswordDialogRef.value.closeDialog()
  } catch {
    message.error('密码重置失败')
  }
}

// 禁用启用用户
const onFreeze = async (record) => {
  await userApi.userFreeze({ id: record.id, freeze: record.freeze == '0' ? '1' : '0' })
  message.success(record.freeze == '0' ? `启用用户:${record.nickName}成功` : `禁用用户:${record.nickName}成功`)
  getTableData()
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(() => {
  getTableData()
})
</script>
<style lang="less" scoped></style>
